import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

export default function showMessage(text) {
  toast.success(text, {
    position: toast.POSITION.TOP_RIGHT,
  });
}
